module.exports = __webpack_public_path__ + "img/logo.f81e92a5.png";